/* global jQuery globalSiteSettings */
(function ($) {
    $(document).ready(function () {
        $('.rating-link').click(function () {
            var contentId = $(this).attr('data-contentid');
            var rating = $(this).attr('data-index');
            var ajax = $.ajax({
                type: 'POST',
                //url: globalSiteSettings.apiUrl+'application_add.json',
                url: globalSiteSettings.apiUrl + '/rate',
                contentType: 'application/json',
                data: JSON.stringify({content_id: contentId, rating: rating})
            });
            ajax.done(function (data) {
                var returnedRatingValue = data.rating;
                var returnedRatingCount = data.count;
                //var returnedRating = Math.floor(Math.random() * Math.floor(5))
                $('.rating-link').each(function () {
                    var index = $(this).attr('data-index');
                    if (index > Math.round(returnedRatingValue)) {
                        $(this).find('.rating-star').removeClass('checked');
                    } else {
                        $(this).find('.rating-star').addClass('checked');
                    }
                });
                $('#spnRatingValue').text(returnedRatingValue);
                $('#spnRatingCount').text(returnedRatingCount);
            });
        });

        $('#rating-stars .rating-link').on('mouseover', function() {
            let onStar = parseInt($(this).data('index'), 10); // The star currently mouse on

            // Now highlight all the stars that's not after the current hovered star
            $(this).parent().children('.rating-link').each(function(e) {
                if (e < onStar) {
                    $(this).addClass('hover');
                } else {
                    $(this).removeClass('hover');
                }
            });
        }).on('mouseout', function(){
            $(this).parent().children('.rating-link').each(function() {
                $(this).removeClass('hover');
            });
        });
    });
})(jQuery);

